<script>
import FlyerPageRenderer from "@/components/page/FlyerPageRenderer.vue";
import {mapGetters} from "vuex";
import GridComponent from "@/components/responsiveGrid.component.vue";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";


export default {
	name: "SearchResultRenderer",
	components: {ConfigStyleInjector, GridComponent, FlyerPageRenderer},
	props: {
		pages: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		...mapGetters('scale', ['defPage', 'defPageGrid', 'unitWidth', 'unitHeight']),
		...mapGetters('search', ['config']),
		aspectColWidth() {
			return this.layout?.useCoords ? null : 135;
		},
		aspectRowHeight() {
			const aspect = this.unitHeight / this.unitWidth;
			return this.layout?.useCoords ? null : this.aspectColWidth * aspect;
		},
		layout() {
			return this.config?.layout || {};
		}
	}
}
</script>

<template>
	<div class="search-result-renderer">
		<config-style-injector :config="layout" :root-selector="`.search-result-renderer`"/>
		<flyer-page-renderer v-if="layout.type === 'simple-tile'"
		                     :col-width="aspectColWidth"
		                     :force-row-count="4"
		                     :page="pages[0]"
		                     :row-height="aspectRowHeight"
		/>
		<flyer-page-renderer v-else-if="layout.type === 'simple-grid'"
		                     :page="pages[0]"
		/>
		<grid-component v-else id="resp-grid"
		                :search-results="true"
		                root-scroll-container="search-scroll-container"
		                v-bind:flyer-pages="pages"
		/>
	</div>

</template>

<style lang="scss" scoped>

</style>
